import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

export class CommunicationsRequestOnVrcAudioUpdateSchema extends CommunicationsRequestSchema {
  public static readonly audioId = 'audioId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////
  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[CommunicationsRequestOnVrcAudioUpdateSchema.audioId] = SchemaField.string(undefined).required();

    return parameters;
  }
}
